import { anyOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isConversationalSettingsResult = objectOf({
  result: objectOf({
    brand_guideline_id: anyOf(string, nullOrUndefined),
    opening_message: anyOf(string, nullOrUndefined),
    chat_max_turns_per_user_per_channel_scope_per_day: anyOf(number, nullOrUndefined),
  }),
});
